import { list } from './list';
import { get } from './get';

export const hookTemplates = {
  list,
  get,
};
